import { createElement } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import type { IconBaseProps, IconType } from 'react-icons';

interface SafeIconProps extends IconBaseProps {
  icon?: IconType;
}

const SafeIcon = ({ icon, 'aria-hidden': ariaHidden = true, focusable = false, ...props }: SafeIconProps) => {
  const IconComponent = icon ?? FiAlertTriangle;

  return createElement(IconComponent, {
    'aria-hidden': ariaHidden,
    focusable,
    ...props,
  });
};

export default SafeIcon;
